import React from 'react';

import { styled } from '@mui/material';
import Tooltip, {
  tooltipClasses,
  type TooltipProps,
} from '@mui/material/Tooltip';
import _ from 'lodash';

import {
  generateMonthList,
  generateWeekList,
  generateYearList,
} from '../utils/helpers';

export const yearlyPeriodList = generateYearList().map((r) => r.value);

export const monthlyPeriodList = generateMonthList()
  .map((m) => generateYearList().map((y) => `${m.value}-${y.value}`))
  .flat();

export const weeklyPeriodList = generateWeekList()
  .map((w) =>
    generateMonthList()
      .map((m) => generateYearList().map((y) => `${w}-${m}-${y}`))
      .flat()
  )
  .flat();

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 1000,
  },
});

export const ModelCompareTooltip = ({
  numberA,
  numberB,
  numberDiff,
  children,
}: {
  numberA: number | '__empty__';
  numberB: number | '__empty__';
  numberDiff: number;
  children: React.ReactElement;
}) => (
  <CustomWidthTooltip
    disableFocusListener
    title={
      <div className="flex gap-3">
        <div className="flex flex-col">
          <span>Model A</span>
          <p className="text-center">
            {_.isNumber(numberA) ? usNumberFormatter.format(numberA) : '--'}
          </p>
        </div>
        <div className="flex flex-col">
          <span>Model B</span>
          <p className="text-center">
            {_.isNumber(numberB) ? usNumberFormatter.format(numberB) : '--'}
          </p>
        </div>
        <div className="flex flex-col">
          <span>Difference</span>
          <p>{usNumberFormatter.format(numberDiff)}</p>
        </div>
      </div>
    }
  >
    {children}
  </CustomWidthTooltip>
);

const usNumberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
